module.exports = __webpack_public_path__ + "assets/5c8a712cb8573f424a58d5796d3b71e8.mp3";